import React, { memo } from 'react';
import type { ModeType } from 'reactApp/ui/OverquotaPopup/newSplash/OverquotaSplash.types';

export const Title: React.FC<{ mode?: ModeType; isMobile?: boolean }> = memo(({ mode, isMobile }) => {
    if (mode === 'cleared') {
        return <>Файлы в Облаке удалены </>;
    }

    if (mode === 'full_blocked') {
        return (
            <>
                Доступ к файлам заблокирован,
                <br />
                но его можно вернуть
            </>
        );
    }

    if (mode === 'after_clear' && !isMobile) {
        return (
            <>
                Доступа к файлам пока нет,
                <br />
                но его можно вернуть
            </>
        );
    }

    return (
        <>
            Доступ к файлам ограничен,
            <br />
            но его можно вернуть
        </>
    );
});

Title.displayName = 'Title';
